"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMount = useMount;
exports.useUnmount = useUnmount;
exports.useUpdate = useUpdate;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _reactRouterDom = require("react-router-dom");

var _react = _interopRequireWildcard(require("react"));

function useMount(cb) {
  (0, _react.useEffect)(function () {
    cb();
  }, []);
}

function useLastLocation(location) {
  var ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    ref['current'] = location;
  }, [location]);
  return ref['current'];
}

function useUpdate(cb) {
  var location = (0, _reactRouterDom.useLocation)();
  var lastLocation = useLastLocation(location);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isRendered = _useState2[0],
      setRendered = _useState2[1];

  (0, _react.useLayoutEffect)(function () {
    if (isRendered) {
      if (location['pathname'] === lastLocation['pathname']) {
        cb();
      }
    } else {
      setRendered(true);
    }
  }, [location]);
}

function useUnmount(cb) {
  (0, _react.useEffect)(function () {
    return function () {
      cb();
    };
  }, []);
}